<script>
  import { onDestroy } from "svelte";
  import { lang } from "../lib/stores";
  import Bars from "./Bars.svelte";

  let selectedLang;
  const unsubscribe = lang.subscribe((value) => selectedLang = value);
  onDestroy(unsubscribe);
  export let data = {};

  $: data;
</script>

<section class="familyChart">
  <div class="p">
    <p>
      {#if selectedLang === 'it'}
        Nei suoi testi, Ghali cita <em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.mother?.count ?? 0)}</em
        >
        volte la parola <em>mamma</em> (o sinonimi tipo <em>madre</em>,
        <em>mother</em>, ecc.) in
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            data?.mother?.songs?.length ?? 0,
          )}</em
        >
        canzoni. <em>Padre</em> (o sinonimi) viene invece citato solo
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(data?.father?.count ?? 0)}</em
        >
        volte in
        <em class="data"
          >{new Intl.NumberFormat("it-IT").format(
            data?.father?.songs?.length ?? 0,
          )}</em
        >
        canzoni. Nota: non sempre le parole che abbiamo aggregato in questo conto
        sono riferite a famigliari: un esempio la canzone <em>Milf</em> contenuta
        in <em>DNA</em>, del 2020; in questo brano il ritornello cantato da
        <em>Taxi B</em>
        recita "<em
          >Tua mamma era una grande milf / E ho sempre cercato di non guardare,
          Hey / E nonostante facessi così / Tu continuavi ad essere un infame</em
        >".
      {:else}
        In his lyrics, Ghali mentions 
        the word <em>mamma</em> (or synonyms such as <em>madre</em> ,
         <em>mother</em> , etc.)
         <em class="data"
          >{new Intl.NumberFormat("en-US").format(data?.mother?.count ?? 0)}</em
        > times in <em class="data"
        >{new Intl.NumberFormat("en-US").format(
          data?.mother?.songs?.length ?? 0,
        )}</em> 
        songs. <em>Padre</em> (or synonyms) is instead mentioned only
        <em class="data"
        >{new Intl.NumberFormat("en-US").format(data?.father?.count ?? 0)}</em>
        times in
        <em class="data"
        >{new Intl.NumberFormat("en-US").format(
          data?.father?.songs?.length ?? 0,
        )}</em>
        songs. Note: the words we have aggregated in this account do not always refer to family members: an example is the song <em>Milf</em> contained in <em>DNA</em> , from 2020; in this song the chorus sung by
         <em>Taxi B</em> 
        goes "<em>Tua mamma era una grande milf / E ho sempre cercato di non guardare,
        Hey / E nonostante facessi così / Tu continuavi ad essere un infame</em>".
      {/if}
    </p>
  </div>
  <div class="familyChart-chart">
    <Bars data={data.terms ?? []} />
  </div>
  <div class="p">
    <blockquote>
      <p>
        Sono uscito dalla melma<br />
        Da una stalla a una stella<br />
        <em>Compro una villa alla mamma</em><br />
        E poi penserò all'Africa<br />
        Figlio di una bidella<br />
        <em>Con papà in una cella</em>
      </p>
      <p>
        <small>Ninna Nanna, Album, 2017</small>
      </p>
    </blockquote>
  </div>
</section>

<style>
  .familyChart {
    display: block;
  }
</style>
